import { render } from "./portal-personal-info.vue?vue&type=template&id=6f5444d8&scoped=true"
import script from "./portal-personal-info.vue?vue&type=script&lang=js"
export * from "./portal-personal-info.vue?vue&type=script&lang=js"

import "./portal-personal-info.vue?vue&type=style&index=0&id=6f5444d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5444d8"]])

export default __exports__